import React from "react";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="bg-[#F5EFE4] min-h-[80vh]">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10 pt-32 pb-20">
        <p className="overline">Legal</p>
        <h1 className="font-serif text-5xl mt-4 text-[#1A1815]">Privacy Policy</h1>
        <p className="text-sm text-[#6B665E] mt-2">Last updated: December 2025</p>
        <div className="mt-10 space-y-8 text-[#1A1815] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl">1. Who We Are</h2>
            <p className="mt-3 text-[#4A453E]">Luxor Services & Concierge Ltd ("Luxor", "we", "us") is the data controller for personal information collected via this website and our services.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">2. What We Collect</h2>
            <ul className="mt-3 text-[#4A453E] space-y-2 list-disc list-inside">
              <li>Contact details (name, email, phone) provided during booking, account registration, or partner application.</li>
              <li>Booking history, preferences and location addresses.</li>
              <li>Payment metadata handled by Stripe (we never store card numbers).</li>
              <li>Technical data such as IP address, browser and cookies.</li>
            </ul>
          </section>
          <section>
            <h2 className="font-serif text-2xl">3. How We Use It</h2>
            <p className="mt-3 text-[#4A453E]">To deliver requested services, process payments, communicate about bookings, improve the platform, and comply with legal obligations. We never sell your data.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">4. Legal Basis (UK GDPR)</h2>
            <p className="mt-3 text-[#4A453E]">Contract performance (bookings), legitimate interests (service improvement), consent (marketing/cookies), and legal obligations (tax records).</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">5. Sharing</h2>
            <p className="mt-3 text-[#4A453E]">We share personal data with vetted service partners strictly to deliver your booking, and with processors including Stripe (payments), Cloudinary (media), and email/SMS providers where enabled.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">6. Your Rights</h2>
            <p className="mt-3 text-[#4A453E]">You have the right to access, correct, delete, or export your personal data, and to object to processing. Contact us at <a className="text-[#C5A059]" href="mailto:info@luxorservicesconcierge.com">info@luxorservicesconcierge.com</a>.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">7. Retention</h2>
            <p className="mt-3 text-[#4A453E]">Booking and financial records are retained for 7 years to meet UK tax requirements. Marketing consent is retained until withdrawn.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">8. Contact</h2>
            <p className="mt-3 text-[#4A453E]">Luxor Services & Concierge Ltd — London, United Kingdom. Email <a className="text-[#C5A059]" href="mailto:info@luxorservicesconcierge.com">info@luxorservicesconcierge.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
